exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.faq-button[data-v-84906910] {\n    bottom: 100px;\n    right: 100px;\n}\n@media screen and (max-width: 800px) {\n.faq-button[data-v-84906910] {\n        bottom: 50px;\n        right: 50px;\n}\n}\n", ""]);

// exports
